import React, { HTMLAttributes, ReactElement } from 'react';
import classNames from 'classnames';

import Rating from '../rating/rating';
import Link from '../link/link';
import Svg from '../svg/svg';
import chat from 'assets/icons/chat.svg';
import './summary.scss';

export interface SummaryInterface {
    title: string;
    url: string;
    average: number;
    count: number;
    image: string;
}

interface SummaryProps extends SummaryInterface, HTMLAttributes<HTMLElement> {
    title: string;
}

const Summary: React.FC<SummaryProps> = ({ title, url, average, count, image, className, ...props }): ReactElement => {
    const summaryClasses = classNames(className, 'summary');

    return (
        <div className={summaryClasses} {...props}>
            <div className="summary__wrapper">
                <h3 className="summary__title">
                    <Link className="summary__title-link" href={url} title={title}>
                        {title}
                    </Link>
                </h3>
                <Rating className="summary__rating" value={average} readOnly={true} />
                <p className="summary__count">
                    <Svg className="summary__count-icon" path={chat} width={14} />
                    <span className="summary__count-text">
                        &ensp;
                        {`(${count} opinii) `}
                    </span>
                </p>
            </div>
            <div className="summary__image-wrapper">
                {image && <img className="summary__image" src={image} alt={title}
                    loading="lazy"
                />}
            </div>
        </div>
    );
};

export default Summary;
